import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsultaAtoComponent } from './components/consulta-ato/consulta-ato.component';
import { VisualizarAtoComponent } from '../atos/components/visualizar-ato/visualizar-ato.component';
import { ImprimirAtoComponent } from '../atos/components/imprimir-ato/imprimir-ato.component';

const routes: Routes = [
    {
        // *** Visualização do Ato pelo app Normas -> Acesso INTERNET, sem login e sem cabeçalho
        path: 'ato',
        children: [
            {
                path: ':id/:tipo/:token',
                component: ConsultaAtoComponent,
                data: {
                    esconderCabecalhoERodape: true,
                }
            },
            {
                path: ':id/visao/:visao/:tipo/:token',
                component: ConsultaAtoComponent,
                data: {
                    esconderCabecalhoERodape: true,
                }
            },
        ]
    },
    {
        // **** Visualização do Ato pela Consulta Externa -> Internet, acesso sem login e com cabeçalho 'Normas'
        path: 'externa',
        children: [
            {
                path: ':id',
                component: VisualizarAtoComponent,
                data: {
                    consultaExterna: true,
                }
            },
            {
                path: ':id/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    consultaExterna: true,
                }
            },
            {
                path: ':id/visao/:visao',
                component: VisualizarAtoComponent,
                data: {
                    consultaExterna: true,
                }
            },
            {
                path: ':id/visao/:visao/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    consultaExterna: true,
                }
            },
            {
                path: ':id/data/:ano/:mes/:dia',
                component: VisualizarAtoComponent,
                data: {
                    consultaExterna: true,
                }
            },
            {
                path: ':id/data/:ano/:mes/:dia/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    consultaExterna: true,
                }
            },
            {
                path: 'imprimir/:id/visao/:visao',
                component: ImprimirAtoComponent,
                data: {
                    consultaExterna: true,
                    breadcrumb: 'Imprimir ato',
                },
            },
            {
                path: 'imprimir/:id/data/:ano/:mes/:dia',
                component: ImprimirAtoComponent,
                data: {
                    consultaExterna: true,
                    breadcrumb: 'Imprimir ato',
                },
            },
        ]
    },
    {
        // **** Visualização do Ato pela Consulta Interna -> Intranet, acesso sem login e com cabeçalho 'Normas Interno'
        path: 'interna',
        children: [
            {
                path: ':id',
                component: VisualizarAtoComponent,
                data: {
                    consultaInterna: true,
                }
            },
            {
                path: ':id/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    consultaInterna: true,
                }
            },
            {
                path: ':id/visao/:visao',
                component: VisualizarAtoComponent,
                data: {
                    consultaInterna: true,
                }
            },
            {
                path: ':id/visao/:visao/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    consultaInterna: true,
                }
            },
            {
                path: ':id/data/:ano/:mes/:dia',
                component: VisualizarAtoComponent,
                data: {
                    consultaInterna: true,
                }
            },
            {
                path: ':id/data/:ano/:mes/:dia/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    consultaInterna: true,
                }
            },
            {
                path: 'imprimir/:id/visao/:visao',
                component: ImprimirAtoComponent,
                data: {
                    consultaInterna: true,
                    breadcrumb: 'Imprimir ato',
                },
            },
            {
                path: 'imprimir/:id/data/:ano/:mes/:dia',
                component: ImprimirAtoComponent,
                data: {
                    consultaInterna: true,
                    breadcrumb: 'Imprimir ato',
                },
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ConsultaRoutingModule { }
